import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import {
  ProductCardConfigurationKeys,
  PRODUCT_CARD_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/product-card-rules';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import { Product, ProductMedia } from 'graphql-api/gql-api-interfaces';
import { Observable } from 'rxjs';

import { ProductCardActionsComponentStore } from './product-card-actions.component-store';

@Component({
  selector: 'epc-product-card-actions',
  styleUrls: ['./product-card-actions.component.scss'],
  templateUrl: './product-card-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductCardActionsComponentStore],
  standalone: false,
})
export class ProductCardActionsComponent {
  private readonly config = inject(ConfigurationsService);
  private readonly componentStore = inject(ProductCardActionsComponentStore);

  @Input()
  public set product(product: Product) {
    this.componentStore.setProduct(product);
  }

  @Input()
  public deletable = false;

  @Input()
  public showBookmarkIcon = true;

  @Input()
  public currentVariantMedia: ProductMedia[] = [];

  @Input()
  public bookMarkNextAvailableVariant = false;

  public readonly product$ = this.componentStore.product$;
  public readonly isBookmarking$ = this.componentStore.isBookmarking$;
  public readonly addedToActiveList$: Observable<boolean> =
    this.componentStore.addedToActiveList();
  public readonly replenishments$ = this.componentStore.replenishments$;

  public readonly previewAttributes$ = this.config.getConfigValue({
    featureName: ProductCardConfigurationKeys.PreviewProductAttributes,
    namespace: PRODUCT_CARD_FEATURE_NAME,
    defaultValue: false,
  });

  protected addProductToActiveList() {
    if (this.bookMarkNextAvailableVariant) {
      this.componentStore.addNextAvailableVariant();
    } else {
      this.componentStore.patchActiveProductList();
    }
  }

  protected removeProductFromActiveList() {
    this.componentStore.patchActiveProductList();
  }

  public deleteFromProductList() {
    this.componentStore.deleteFromProductList();
  }
}
